import React, { useMemo, useReducer } from "react";
import { useState } from "react";
import { useTheme } from "../hooks/fetch_api_hook/useTheme";
import { useThemeEnCache } from "../hooks/fetch_api_hook/useThemeEnCache";
import { exercicesDepuisSelection } from "../utils/exercicesEvaluation";
import { chiffreNiveau } from "../components/CollerNotes/PastilleNiveau";
import StepProgressBar from "../components/FormEvaluation/StepProgressBar";
import InfoEval from "../components/FormEvaluation/InfoEval";
import InfoSavoirs from "../components/FormEvaluation/InfoSavoirs";
import InfoCompetences from "../components/FormEvaluation/InfoCompetences";
import { usePostApi } from "../hooks/post_api_hook/usePostApi";
import { useParams, useNavigate } from "react-router-dom";
import { addEvalReducer } from "../reducers/addEvalReducer";
import { formatDate } from "../utils/ClasseEvaluations";
import { useClasseContext } from "../context/ClasseContext";
import { url } from "../utils/confserveur";
import { useUser } from "../context/UserContext";
import Loading from "../components/general/Loading";
import AlertModal from "../components/general/AlertModal";
import { getSlidingYearRange } from "../utils/sequencesfunction";

const formatBackendError = (error) => {
  const data = error?.response?.data;
  if (!data) return "Erreur lors de l'envoi de l'évaluation.";
  if (typeof data === 'string') return data;
  if (data.error) return data.error;
  return Object.entries(data)
    .map(([k, v]) => `${k} : ${Array.isArray(v) ? v.join(', ') : v}`)
    .join('\n');
};

function AddEvaluation({niveau, cible, professeurReferents}) {
 

  const {idclasse} = useParams();
  const initialState = {
    subjectFile: null,
    correctionFile: null,
    title: niveau? "Devoir Commun" : "",
    comments: '',
    step: 1,
    selectedTheme: '',
    selectedDescripteur: '',
    selectedSavoirs: [],
    selectedAttendus: [],
    selectedComps: [],
    evalDate: "",
    postEvalDate: '',
  };
    const [descripteurs, setDescripteurs] = useState([])
    const [savoirs, setSavoirs] = useState([])
    const [attendus,setAttendus] = useState([])
    const [evalInfo, dispatch] = useReducer(addEvalReducer, initialState);
    const {classeNom, groupNom, classesGroup} = useClasseContext();
    const {etablissementData} = useUser();

    const steps = [
      { step: 1, label: 'Informations générales' },
      { step: 2, label: 'Savoirs-faires' },
      { step: 3, label: 'Compétences' },
        ];

        const {data: ThemeDetail, isLoading, isError} = useTheme(
          !niveau 
          ? (classeNom ? classeNom[0] : classesGroup.length > 0  && classesGroup[0][0]) 
          : niveau
      );

      // Autre niveau (2026-09-29, demande de deux profs ; rare, donc discret) :
      // un petit menu « Niveau » à l'étape des attendus, réglé sur la classe.
      // Pas en devoir commun (prop `niveau`), hors périmètre. null = la classe.
      const niveauClasse = niveau ? '' : chiffreNiveau(classeNom ? classeNom[0] : (classesGroup.length > 0 && classesGroup[0][0]));
      const [niveauChoisi, setNiveauChoisi] = useState(null);
      const autreNiveau = Boolean(niveauClasse && niveauChoisi && niveauChoisi !== niveauClasse);
      const { data: themesAutre, isLoading: chargementAutre } = useThemeEnCache(niveauChoisi, autreNiveau);

    
      // Récupération des données de l'API après la requete POST pour une évaluation.
    const [{ isLoading: isLoadingPost}, doPost] = usePostApi(url + "evaluations/");

    // L'arbre affiché : celui du niveau choisi, sinon celui de la classe
    // (null tant que l'arbre de la classe n'est pas arrivé).
    const themeforCycle = useMemo(() => {
      if (autreNiveau) return themesAutre;
      return Array.isArray(ThemeDetail) ? ThemeDetail : null;
    }, [autreNiveau, themesAutre, ThemeDetail]);
    const [alertModal, setAlertModal] = useState(null);
    const navigate = useNavigate();

  const {min, max} = getSlidingYearRange();



       // Fonction pour l'implémentation des menus déroulant.
      const getDescripteursForTheme = (themeNom) => {
          const theme = themeforCycle.find(t =>  t.nom === themeNom)
          return theme ? theme.descripteur : [];
      } 
      const getSavoirsForDescripteur = (DescripteurNom) => {
        // On parcourt chaque theme
        for (let theme of themeforCycle) {
          const descripteur = theme.descripteur.find(d=> d.nom === DescripteurNom)
          if(descripteur){
            return descripteur.savoirs_faires;
          }
        }
      }

    
      const getAttendusForDescripteur = (DescripteurNom) => {
        // On parcourt chaque theme
        for (let theme of themeforCycle) {
          const descripteur = theme.descripteur.find(d=> d.nom === DescripteurNom)
          if(descripteur){
            return descripteur.attendus;
          }
        }
      }

      // Les exercices du POST : exercicesDepuisSelection (utils/exercicesEvaluation).

      // Les handles

    const handleSubjectFileChange = (event) => {
        dispatch({type: "SET_SUBJECT_FILE", payload: event.target.files[0]})
      }

      const handleCorrectionFileChange = (event) => {
        dispatch({type: "SET_CORRECTION_FILE", payload: event.target.files[0]})
      };


      const handleTitleChange = (event) => {
        const inputValue = event.target.value;
      
        // Vérifie si "Devoir commun" (insensible à la casse) est présent dans l'entrée
        if (/devoir commun/i.test(inputValue)) {
          alert("Attention ! Seul le coordonateur peut créer un devoir commun.");
          return; // Stoppe l'exécution si la condition est remplie
        }
      
        // Si tout va bien, on met à jour le titre
        dispatch({ type: "SET_TITLE", payload: inputValue });
      };

    const handleCommentsChange = (event) => {
      dispatch({type: "SET_COMMENTS", payload: event.target.value})
    }
    
    const handleThemeChange = (item ) => {
      dispatch({type: "SET_THEME", payload: item})
      setDescripteurs(getDescripteursForTheme(item))
      setSavoirs('');
      setAttendus('');
    }

    const handleDescripteurChange = (item) => {
        dispatch({type: "SET_DESCRIPTORS", payload: item})
        setSavoirs(getSavoirsForDescripteur(item));
        setAttendus(getAttendusForDescripteur(item));
    }

    // Changer de niveau repart du choix du thème ; les attendus déjà cochés
    // (de ce niveau ou d'un autre) restent cochés.
    const handleNiveauChange = (n) => {
      setNiveauChoisi(n);
      dispatch({type: "SET_THEME", payload: ''});
      dispatch({type: "SET_DESCRIPTORS", payload: ''});
      setDescripteurs([]);
      setSavoirs([]);
      setAttendus([]);
    }

    const handleSavoirChange = (savoir,savoirId) => {
      dispatch({type: "SET_KNOWLEDGE" , payload: savoir});
    };
    
    const handleAttenduChange = (attendu,attenduId) => {
      dispatch({type: "SET_ATTENDUS" , payload: attendu});
    };
    const handleCompChange = (savoir,comp,type) => { 
      dispatch({type: "SET_COMPETENCES", payload: {savoir, comp,type}});
  }
     
  
    const handleNext = (event) => {
        dispatch( {type: "NEXT_STEP", step: evalInfo.step} )
    }

    const handlePrev = (event) => {
      // Utilise l'état précédent pour déterminer le nouveau, ce qui garantit 
// que l'état est à jour même si les mises à jour d'état sont asynchrones.
    // Calculer la nouvelle étape après décrémentation
  // On décrémente l'étape
  dispatch({ type: "PREV_STEP", step: evalInfo.step });
  }

  // Fonction de changement de la date.
  const handleDateChange = (e) => {
    const date = e.target.value;
  
    dispatch({type: "SET_EVAL_DATE", payload : date})
    dispatch({type:"POST_EVAL_DATE", payload: formatDate(date)})
  }


    const handleSubmit = async (event) => {
        event.preventDefault();
        // Ici vous pouvez gérer l'envoi des données du formulaire, par exemple avec un appel à une API.
            // Préparation des données de l'évaluation
          
            const postData = {
              evaluation : {
                "titre" : evalInfo.title,
                "date" : `${evalInfo.postEvalDate}`,
                "classe" : classeNom  ? parseInt(idclasse) : null,
                "groupe" : groupNom ? parseInt(idclasse) : null,
                "niveau": niveau ? niveau : null,
                // 'classes' | 'groupes' pour devoir commun, null pour évaluation classe/groupe individuelle
                "cible": niveau ? (cible || 'classes') : null,
                "etablissement_id" : etablissementData.id,
                "statut": "en_attente",
                "professeurReferents" : professeurReferents
              },
              exercices: exercicesDepuisSelection(evalInfo.selectedComps)
            };


            const result = await doPost(postData);

            // Échec HTTP (400 backend, validation DRF, réseau...) → on bloque la nav et on affiche le message backend
            if (!result.success) {
              setAlertModal({
                variant: 'error',
                title: 'Création impossible',
                message: formatBackendError(result.error),
                onClose: () => setAlertModal(null),
              });
              return;
            }

            // Devoir commun : 201 mais aucune classe/groupe matchée → succès "vide" à signaler explicitement
            if (niveau && result.data?.evaluations_creees === 0) {
              const cibleLabel = cible === 'groupes' ? 'groupe' : 'classe';
              setAlertModal({
                variant: 'info',
                title: 'Aucune évaluation créée',
                message: `Aucune ${cibleLabel} de niveau ${niveau} ne correspond aux critères de votre établissement et de votre matière.`,
                onClose: () => setAlertModal(null),
              });
              return;
            }

            // Succès devoir commun (≥ 1 évaluation créée) : confirmation puis navigation à la fermeture
            if (niveau) {
              setAlertModal({
                variant: 'success',
                title: 'Devoir commun créé',
                message: result.data?.message ?? `Devoir commun créé pour ${result.data?.evaluations_creees} ${cible === 'groupes' ? 'groupe(s)' : 'classe(s)'}.`,
                onClose: () => { setAlertModal(null); navigate('/home/common-eval'); },
              });
              return;
            }

            // Succès évaluation standard : navigation directe (comportement historique)
            navigate(`/home/evals/${idclasse}`);
      };

      if(isLoading){
        return <div> Chargement ....</div>
      }
      if(isError){
        return <div> Erreur lors du chargement des données...</div>
      }

      // Garde-fou classe vide (flux CLASSE uniquement — le devoir commun,
      // prop `niveau`, a sa propre garde côté niveau) : la carte « J'ai déjà
      // mon sujet » est masquée sans élèves, mais l'URL directe
      // /home/evals/:id/add restait ouverte sur le formulaire complet.
      {
        const classeCourante = !niveau && etablissementData?.classes?.find(c => c.id === parseInt(idclasse, 10));
        if (classeCourante && !(classeCourante.nombre_eleves > 0)) {
          return (
            <div className="flex flex-col items-center justify-center py-16 px-4 w-full">
              <div className="w-16 h-16 bg-amber-50 border border-amber-300 rounded-full flex items-center justify-center mb-4">
                <span className="text-3xl">📭</span>
              </div>
              <h2 className="text-xl font-extrabold text-slate-800 mb-2">Classe sans élèves</h2>
              <p className="text-slate-500 text-center max-w-md text-sm sm:text-base font-semibold mb-6">
                Impossible de créer une évaluation de suivi sans élèves : la saisie
                des notes n'aurait personne à noter. Importez d'abord les élèves de la classe.
              </p>
              <button
                onClick={() => navigate(`/home/creer/${idclasse}`)}
                className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold text-sm transition"
              >
                ← Retour à la création
              </button>
            </div>
          );
        }
      }

    return(

      <>   {themeforCycle &&  <div className="flex flex-col overflow-auto w-full">
      
    <StepProgressBar steps={steps} currentStep={evalInfo.step} />

      <div className="  flex  justify-center  ">
     
      {evalInfo.step===1 &&
       <InfoEval 
       handleSubjectFileChange={handleSubjectFileChange}
       handleCorrectionFileChange={handleCorrectionFileChange}
       comments={evalInfo.comments}
       handleNext={handleNext}
       handleTitleChange={handleTitleChange}
       title = {evalInfo.title}
       handleCommentsChange={handleCommentsChange}
       evalDate = {evalInfo.evalDate}
       handleDateChange={handleDateChange}
       niveau={niveau}
        />}

      {evalInfo.step ===2 && 
      <InfoSavoirs ThemeDetail = {themeforCycle} handleThemeChange ={handleThemeChange} handleDescripteurChange={handleDescripteurChange} 
      selectedTheme={evalInfo.selectedTheme}
      descripteurs={descripteurs}
      selectedDescripteur={evalInfo.selectedDescripteur}
      handleNext={handleNext}
      handlePrev={handlePrev}
      savoirs={savoirs}
      attendus={attendus}
      handleSavoirChange = {handleSavoirChange}
      handleAttenduChange={handleAttenduChange}
      selectedSavoirs = {evalInfo.selectedSavoirs}
      selectedAttendus= {evalInfo.selectedAttendus}
      niveauClasse={niveauClasse}
      niveauAttendus={niveauChoisi || niveauClasse}
      onChangeNiveau={niveauClasse ? handleNiveauChange : undefined}
      chargementNiveau={autreNiveau && chargementAutre}
       />
      }

  {evalInfo.step ===3 && 
  <div className="flex flex-col gap-5 items-center">
      <InfoCompetences handlePrev={handlePrev}
      selectedSavoirs={evalInfo.selectedSavoirs}
      selectedAttendus={evalInfo.selectedAttendus}
      selectedComps={evalInfo.selectedComps}
      selectedDescripteur={evalInfo.selectedDescripteur}
      onChange={handleCompChange}
      selectedTheme={evalInfo}
      handleSubmit={handleSubmit}
      isLoadingPost={isLoadingPost}
      niveauClasse={niveauClasse}
       />


       </div>
      }

    
      </div>
      {isLoading && <div> Envoi en cours ....</div>}
      {isLoadingPost && <Loading loadingText={"Envoi des données en cours..."} /> }
      {isError && <div> Erreur lors de l'envoi des données ! </div>}
</div>}

      {alertModal && <AlertModal {...alertModal} />}
      </>
    )
}

export default AddEvaluation;